import { Select, Card, Typography, Space, Avatar, List, Tag, Tooltip, Flex, Checkbox, Button, Divider } from "antd"
import { CloseCircleOutlined } from "@ant-design/icons"
import { getInitials } from "../scheduleModel"
import { EventFormState } from "./useEventFormState"

const { Text } = Typography

type Props = {
  formState: EventFormState
  showNotificationOption: boolean
}

const EventFormCrewFields = ({ formState, showNotificationOption }: Props) => {
  const {
    formValues,
    setFormValues,
    crew,
    handleCrewSelect,
    removeCrewMember,
    toggleCrewLead,
  } = formState

  const {
    selectedCrew,
    crewLeadId,
    sendCrewLeadNotifications,
  } = formValues

  return (
    <div style={{ marginBottom: "24px" }}>
      <Text style={{ fontSize: "14px", display: "block", marginBottom: "8px" }}>
        Crew Members
      </Text>
      <Card>
        <Select
          showSearch
          placeholder="Search and select crew members"
          optionFilterProp="label"
          style={{ width: "100%", marginBottom: "16px" }}
          onChange={handleCrewSelect}
          value={selectedCrew?.map((member) => member?.id).filter(Boolean) || []}
          allowClear
          mode="multiple"
          maxTagCount={3}
          maxTagTextLength={10}
        >
          {crew?.map((member) => (
            <Select.Option key={member.id} value={member.id} label={member.name}>
              <Space>
                <Avatar
                  src={member.hasStockAvatar ? undefined : member.avatar}
                  size="small"
                  style={
                    member.hasStockAvatar || !member.avatar
                      ? { backgroundColor: member.color || "#d9d9d9", color: "#fff" }
                      : undefined
                  }
                >
                  {getInitials(member.name)}
                </Avatar>
                <span>{member.name}</span>
              </Space>
            </Select.Option>
          ))}
        </Select>

        {selectedCrew.length > 0 ? (
          <List
            size="small"
            dataSource={selectedCrew}
            renderItem={(member) => (
              <List.Item
                actions={[
                  !member.userEmail ? (
                    <Tooltip
                      key="setLead"
                      title="Crew member needs an email address to be a crew lead"
                    >
                      <Button
                        type="link"
                        size="small"
                        disabled
                        style={{ padding: 0, cursor: "not-allowed" }}
                      >
                        Set as Crew Lead
                      </Button>
                    </Tooltip>
                  ) : (
                    <a
                      key="setLead"
                      onClick={() => toggleCrewLead(member.id)}
                      style={{
                        color: crewLeadId === member.id ? "#d4380d" : "#1890ff",
                      }}
                    >
                      {crewLeadId === member.id
                        ? "Remove Crew Lead"
                        : "Set as Crew Lead"}
                    </a>
                  ),
                  <a key="remove" onClick={() => removeCrewMember(member.id)}>
                    <CloseCircleOutlined style={{ fontSize: "16px" }} />
                  </a>,
                ]}
              >
                <List.Item.Meta
                  avatar={
                    <Avatar
                      src={member.hasStockAvatar ? undefined : member.avatar}
                      size="small"
                      style={
                        member.hasStockAvatar || !member.avatar
                          ? {
                            backgroundColor: member.color || "#d9d9d9",
                            color: "#fff",
                          }
                          : undefined
                      }
                    >
                      {getInitials(member.name)}
                    </Avatar>
                  }
                  title={
                    <Space>
                      {member.name}
                      {crewLeadId === member.id && (
                        <Tag color="gold">Crew Lead</Tag>
                      )}
                    </Space>
                  }
                />
              </List.Item>
            )}
          />
        ) : (
          <Flex
            vertical
            justify="center"
            align="center"
            style={{
              flex: 1,
              border: "1px dashed #d9d9d9",
              borderRadius: "8px",
              padding: "16px",
              maxHeight: "120px",
            }}
          >
            <Text type="secondary">No Assigned Crew</Text>
          </Flex>
        )}

        {crewLeadId && showNotificationOption && <>
          <Divider />
          <div>
            <Checkbox
              checked={sendCrewLeadNotifications}
              onChange={(e) => setFormValues({ sendCrewLeadNotifications: e.target.checked })}
            >
              Send scheduling notifications to crew lead
            </Checkbox>
          </div>
        </>}
      </Card>
    </div>
  )
}

export default EventFormCrewFields
